/**
 * Swedish (Svenska) translations for To To-Do v2.
 *
 * Pattern: English-text-as-key → Swedish value.
 * Adapted from v1 sv.ts (~719 keys) plus new v2-specific strings.
 *
 * Organised by feature area matching src/features/* structure.
 */

/* eslint-disable @typescript-eslint/no-unused-vars */
export const sv: Record<string, string> = {
  locale: "sv",

  // ===========================================================================
  // NAVIGATION — Sidebar, AddMenu, TopNavBar
  // ===========================================================================
  Inbox: "Inkorg",
  Today: "Idag",
  Upcoming: "Kommande",
  Anyday: "När som helst",
  Someday: "Någon dag",
  Logbook: "Loggbok",
  Trash: "Papperskorg",
  Invites: "Inbjudningar",
  "Later Projects": "Senare projekt",
  "1 later project": "1 senare projekt",
  "{{count}} later projects": "{{count}} senare projekt",
  "New List": "Ny lista",
  "New Project": "Nytt projekt",
  "New Area": "Nytt område",
  "New Section": "Ny rubrik",
  "New To-Do": "Ny uppgift",
  New: "Nytt",
  "Expand area": "Expandera område",
  "Collapse area": "Fäll ihop område",
  "Open sidebar menu": "Öppna sidomenyn",
  "Sidebar navigation": "Sidonavigation",
  "Add To-Do": "Lägg till uppgift",
  "Quickly add a to-do to your inbox":
    "Snabbt lägga till en uppgift i din inkorg",
  "Define a goal, then work towards it one to-do at a time.":
    "Definiera ett mål och arbeta mot det en uppgift i taget.",
  "Compile items or tasks for easy organization and planning.":
    "Samla punkter eller uppgifter för enkel organisering och planering.",
  "Group projects and to-dos based on different responsibilities, such as Family or Work":
    "Gruppera projekt och uppgifter baserat på olika ansvarsområden, som Familj eller Arbete",
  Tmrw: "Imrg",
  "{{count}}d": "{{count}}d",

  // ===========================================================================
  // SEARCH
  // ===========================================================================
  Search: "Sök",
  "Search tasks, lists, projects…": "Sök uppgifter, listor, projekt…",
  "Quick switch lists, find to-dos, search tags":
    "Snabbväxla listor, hitta uppgifter, sök taggar",
  "No results found": "Inga resultat hittades",
  "Try a different search term": "Försök med en annan sökterm",

  // ===========================================================================
  // VIEWS — viewRegistry, ViewShell, pages
  // ===========================================================================
  "This Evening": "I kväll",
  Project: "Projekt",
  List: "Lista",
  Area: "Område",

  // Empty states
  "All clear": "Allt klart",
  "Nothing planned for today": "Inget planerat för idag",
  "Evenings free": "Kvällen ledig",
  "No tasks planned for this evening": "Inga uppgifter planerade för ikväll",
  "Inbox zero": "Inkorg tom",
  "All tasks have been sorted": "Alla uppgifter har sorterats",
  "Nothing upcoming": "Inget kommande",
  "No tasks scheduled for the future":
    "Inga uppgifter schemalagda för framtiden",
  "No tasks": "Inga uppgifter",
  "Tasks available any time will appear here":
    "Uppgifter tillgängliga när som helst visas här",
  "Nothing deferred": "Inget uppskjutet",
  "Tasks you defer to someday will appear here":
    "Uppgifter du skjuter upp till någon dag visas här",
  "Logbook empty": "Loggboken tom",
  "Completed and cancelled tasks will appear here":
    "Slutförda och avbrutna uppgifter visas här",
  "Trash is empty": "Papperskorgen är tom",
  "Deleted items are kept here for 30 days":
    "Borttagna objekt sparas här i 30 dagar",
  "No results": "Inga resultat",
  "Add a task to get started": "Lägg till en uppgift för att komma igång",
  "No items": "Inga objekt",
  "Add an item to get started": "Lägg till ett objekt för att komma igång",
  "Empty area": "Tomt område",
  "Projects and lists in this area will appear here":
    "Projekt och listor i detta område visas här",
  "No matching tasks": "Inga matchande uppgifter",
  "No tasks match tag #{{tags}}": "Inga uppgifter matchar taggen #{{tags}}",
  "Drop here": "Släpp här",
  "Show {{count}} more": "Visa {{count}} till",
  "Show {{count}} logged": "Visa {{count}} i loggboken",
  "Hide {{count}} logged": "Dölj {{count}} i loggboken",
  "Show top {{count}}": "Visa topp {{count}}",

  // Trash page
  "Emptying…": "Tömmer…",
  "Empty trash": "Töm papperskorg",
  "Find tasks, projects, and lists": "Hitta uppgifter, projekt och listor",

  // ===========================================================================
  // SCHEDULE — SchedulePicker, DatePickerSheet, ReminderSection, DeadlineSheet
  // ===========================================================================
  "When?": "När?",
  Tomorrow: "Imorgon",
  "Pick a date…": "Välj ett datum…",
  "Clear date": "Rensa datum",
  Deadline: "Deadline",
  "Clear deadline": "Rensa deadline",
  "Remove deadline": "Ta bort deadline",
  "Add Deadline": "Lägg till deadline",
  Schedule: "Schema",
  Reminder: "Påminnelse",
  "Schedule task": "Schemalägg uppgift",
  "Due today": "Förfaller idag",
  "Due tomorrow": "Förfaller imorgon",
  "Due {{date}}": "Förfaller {{date}}",
  "Next week": "Nästa vecka",

  // Reminder presets
  "Later today": "Senare idag",
  Tonight: "Ikväll",
  "Tomorrow 09:00": "Imorgon 09:00",
  "Tmrw 09:00": "Imrn 09:00",
  "In 10 min": "Om 10 min",
  "In 30 min": "Om 30 min",
  "In 1 hour": "Om 1 timme",
  "Early morning (07:00)": "Tidig morgon (07:00)",
  "Morning (09:00)": "Morgon (09:00)",
  "Midday (12:00)": "Mitt på dagen (12:00)",
  "Afternoon (15:00)": "Eftermiddag (15:00)",
  "Evening (19:00)": "Kväll (19:00)",
  "Day before (18:00)": "Dagen innan (18:00)",
  "Remind me {{date}} at {{time}}": "Påminn mig {{date}} kl {{time}}",
  Quick: "Snabb",
  Advanced: "Avancerad",
  "Quick select": "Snabbval",
  "Based on task day": "Baserat på uppgiftens dag",
  Time: "Tid",
  Alarm: "Alarm",
  Save: "Spara",
  "Saving…": "Sparar…",
  "Add Reminder": "Lägg till påminnelse",
  "Remove reminder": "Ta bort påminnelse",

  // ===========================================================================
  // TASK DETAIL
  // ===========================================================================
  Move: "Flytta",
  Delete: "Radera",
  Restore: "Återställ",
  Close: "Stäng",
  "Moved to trash": "Flyttad till papperskorgen",
  Undo: "Ångra",
  "Add notes…": "Lägg till anteckningar…",
  "Schedule ({{shortcut}})": "Schema ({{shortcut}})",
  "Add tag ({{shortcut}})": "Lägg till tagg ({{shortcut}})",
  "Add checklist": "Lägg till checklista",
  "Add deadline ({{shortcut}})": "Lägg till deadline ({{shortcut}})",
  "Set status": "Sätt status",

  // Task detail dates
  "Tomorrow evening": "Imorgon kväll",
  "{{date}} evening": "{{date}} kväll",
  "1 day overdue": "1 dag försenad",
  "{{count}} days overdue": "{{count}} dagar försenad",
  "1 day left": "1 dag kvar",
  "{{count}} days left": "{{count}} dagar kvar",
  "tomorrow {{time}}": "imorgon {{time}}",

  // Checklist status
  Unfinished: "Oavslutad",
  Open: "Öppen",
  Completed: "Slutförd",
  Done: "Klar",
  Canceled: "Avbruten",
  Cancel: "Avbryt",

  // ===========================================================================
  // TASK COMPONENTS — QuickAdd, TaskInput, StatusSelector, SectionRow, TaskItem
  // ===========================================================================
  "New task…": "Ny uppgift…",
  "New task...": "Ny uppgift...",
  Add: "Lägg till",
  Status: "Status",
  "To Do": "Att göra",
  Untitled: "Namnlös",
  "(no title)": "(ingen titel)",
  "Change schedule": "Ändra schema",
  "Deselect task": "Avmarkera uppgift",
  "Select task": "Välj uppgift",
  "Section options": "Rubrik-alternativ",

  // ===========================================================================
  // PROJECT HEADER
  // ===========================================================================
  "Project is in the trash": "Projektet är i papperskorgen",
  "List is in the trash": "Listan är i papperskorgen",
  "Mark {{typeLabel}} as incomplete": "Markera {{typeLabel}} som ofullständigt",
  "Complete {{typeLabel}}": "Slutför {{typeLabel}}",
  "Project moved to trash": "Projekt flyttat till papperskorgen",
  "List moved to trash": "Lista flyttad till papperskorgen",
  "Project deleted": "Projekt raderat",
  "List deleted": "Lista raderad",
  "Project restored": "Projekt återställt",
  "List restored": "Lista återställd",
  Reopen: "Öppna igen",
  Complete: "Slutför",
  When: "När",
  "Add Section": "Lägg till rubrik",
  "Add Tags": "Lägg till taggar",
  "Duplicate {{typeLabel}}": "Duplicera {{typeLabel}}",
  "Convert to list": "Konvertera till lista",
  "Convert to project": "Konvertera till projekt",
  "Share…": "Dela…",
  "Delete this {{typeLabel}}, {{title}}?":
    "Radera denna {{typeLabel}}, {{title}}?",
  "{{count}} item(s) that you haven't completed":
    "{{count}} objekt som du inte har slutfört",
  "Complete this {{typeLabel}}?": "Slutföra denna {{typeLabel}}?",
  "Cancel this {{type}}, {{title}}?": "Avbryta {{type}} {{title}}?",
  "Complete this {{type}}, {{title}}?": "Slutföra {{type}} {{title}}?",
  "Mark remaining to-dos as completed":
    "Markera återstående uppgifter som slutförda",
  "Mark remaining to-dos as canceled":
    "Markera återstående uppgifter som avbrutna",
  "{{count}} to-do was closed with this project. Reopen it too?":
    "{{count}} uppgift stängdes med projektet. Öppna den också?",
  "{{count}} to-dos were closed with this project. Reopen them too?":
    "{{count}} uppgifter stängdes med projektet. Öppna dem också?",
  "{{count}} to-do was closed with this list. Reopen it too?":
    "{{count}} uppgift stängdes med listan. Öppna den också?",
  "{{count}} to-dos were closed with this list. Reopen them too?":
    "{{count}} uppgifter stängdes med listan. Öppna dem också?",

  // ===========================================================================
  // AREA HEADER
  // ===========================================================================
  "Delete Area": "Radera område",
  "Are you sure you want to delete this area?":
    "Är du säker på att du vill radera detta område?",
  "Area deleted": "Område raderat",

  // ===========================================================================
  // DATE UTILITIES — shared date formatting
  // ===========================================================================
  Yesterday: "Igår",
  "{{count}} days": "{{count}} dagar",
  "{{count}} days ago": "{{count}} dagar sedan",

  // ===========================================================================
  // USER STATUS — shared status labels
  // ===========================================================================
  Idea: "Idé",
  Ready: "Redo",
  "In Progress": "Pågående",
  Waiting: "Väntar",
  Blocked: "Blockerad",
  Review: "Granskning",
  Testing: "Testning",
  Approved: "Godkänd",
  Deployed: "Publicerad",
  "On Hold": "Pausad",
  Deferred: "Uppskjuten",
  Rejected: "Avvisad",
  Cancelled: "Avbruten",
  Unknown: "Okänd",
  "Clear status": "Rensa status",

  // ===========================================================================
  // SETTINGS — Structure
  // ===========================================================================
  Settings: "Inställningar",
  "Back to settings menu": "Tillbaka till inställningsmenyn",
  "Close settings": "Stäng inställningar",
  "Search settings…": "Sök inställningar…",
  "No matching settings found.": "Inga matchande inställningar hittades.",
  Confirm: "Bekräfta",

  // Settings categories
  Profile: "Profil",
  General: "Allmänt",
  Account: "Konto",
  Devices: "Enheter",
  Appearance: "Utseende",
  Notifications: "Aviseringar",
  Statuses: "Statusar",
  Calendar: "Kalender",
  Email: "E-post",
  "Import & Export": "Import & Export",
  Help: "Hjälp",
  About: "Om",
  Developer: "Utvecklare",

  // ===========================================================================
  // SETTINGS — General (settingsConfig.ts)
  // ===========================================================================
  Language: "Språk",
  "Week starts on": "Veckan börjar på",
  Sunday: "Söndag",
  Monday: "Måndag",
  Tuesday: "Tisdag",
  Wednesday: "Onsdag",
  Thursday: "Torsdag",
  Friday: "Fredag",
  Saturday: "Lördag",
  "System ({{day}})": "System ({{day}})",
  "Default view": "Standardvy",
  "Flat Today view": "Platt Idag-vy",
  "Drop position": "Släpp-position",
  "Before first section": "Före första rubriken",
  "End of list": "Slutet av listan",
  "After last task": "Efter sista uppgiften",
  "Evening time": "Kvällstid",
  Haptics: "Haptik",
  "Push notifications": "Push-aviseringar",
  "Select language…": "Välj språk…",
  "Search language…": "Sök språk…",
  "No languages found": "Inga språk hittades",
  " (default)": " (standard)",
  "Choose the language for the app interface. By default, it follows your system language.":
    "Välj språket för appens gränssnitt. Som standard följer det ditt systemspråk.",
  "Set which day of the week your calendar views should start on.":
    "Ställ in vilken dag i veckan dina kalendervyer ska börja på.",

  // ===========================================================================
  // SETTINGS — Appearance
  // ===========================================================================
  System: "System",
  Light: "Ljus",
  Dark: "Mörk",
  Theme: "Tema",
  "Theme variant": "Temavariant",
  "Accent color": "Accentfärg",
  Zoom: "Zoom",
  "Color mode": "Färgläge",
  "Enable colorful per-type icons in the sidebar and nav — or keep it minimal.":
    "Aktivera färgglada ikoner per typ i sidofältet — eller håll det minimalt.",
  "Sidebar zoom": "Sidofältszoom",
  "Content zoom": "Innehållszoom",
  "Select the app's theme. Use the system setting or switch to light or dark mode manually.":
    "Välj appens tema. Använd systeminställningen eller växla manuellt mellan ljust eller mörkt läge.",
  "Personalize the app by choosing an accent color used for buttons and highlights.":
    "Anpassa appen genom att välja en accentfärg som används för knappar och markeringar.",

  // ===========================================================================
  // SETTINGS — Profile
  // ===========================================================================
  "Display name": "Visningsnamn",
  "Add your name": "Lägg till ditt namn",
  "Name updated": "Namn uppdaterat",
  "Could not save name": "Kunde inte spara namn",
  "Profile picture updated!": "Profilbild uppdaterad!",
  "Could not save profile picture": "Kunde inte spara profilbild",

  // ===========================================================================
  // SETTINGS — Account
  // ===========================================================================
  "Current plan": "Nuvarande plan",
  Demo: "Demo",
  Free: "Gratis",
  Standard: "Standard",
  Premium: "Premium",
  "Payment issue": "Betalningsproblem",
  Inactive: "Inaktiv",
  Active: "Aktiv",
  "Upgrade to unlock sync, backup, and collaboration.":
    "Uppgradera för att låsa upp synk, backup och samarbete.",
  "/ year": "/ år",
  "/ 2 years": "/ 2 år",
  "/ month": "/ månad",
  "Renews {{date}}": "Förnyas {{date}}",
  "Discount: {{amount}}% off": "Rabatt: {{amount}}% av",
  "(forever)": "(för alltid)",
  "(one-time)": "(engångs)",
  "Manage subscription": "Hantera prenumeration",
  Plans: "Planer",
  Month: "Månad",
  Year: "År",
  Current: "Nuvarande",
  Upgrade: "Uppgradera",
  "Promo codes": "Kampanjkoder",
  "Enter promo code": "Ange kampanjkod",
  "Note: Promo codes only give discounts on web purchases. If you buy in the app, your code still supports the partner.":
    "Obs: Kampanjkoder ger endast rabatter på webbköp. Om du köper i appen stöder din kod fortfarande partnern.",
  "Log out": "Logga ut",
  "Log out?": "Logga ut?",
  "Ensure your data is synced before logging out. You can log back in anytime.":
    "Se till att din data är synkroniserad innan du loggar ut. Du kan logga in igen när som helst.",
  "Delete account": "Radera konto",
  "Delete account?": "Radera konto?",
  "I'm not using the app anymore": "Jag använder inte appen längre",
  "Found a better alternative": "Hittade ett bättre alternativ",
  "Too expensive": "För dyrt",
  "Missing features I need": "Saknar funktioner jag behöver",
  "Too complicated to use": "För komplicerat att använda",
  "Had technical problems": "Hade tekniska problem",
  "Other reason": "Annan anledning",
  "Additional feedback (optional)": "Ytterligare feedback (valfritt)",
  "Tell us more about your experience...": "Berätta mer om din upplevelse...",
  "Deleting…": "Raderar…",
  "To confirm, type {{placeholder}} below":
    "För att bekräfta, skriv {{placeholder}} nedan",
  "DELETE ACCOUNT": "TA BORT KONTO",
  "Please tell us why you're leaving":
    "Var vänlig och berätta varför du lämnar oss",

  // ===========================================================================
  // SETTINGS — Devices
  // ===========================================================================
  "My devices": "Mina enheter",
  "View and manage all devices that are or have been logged in to your account.":
    "Visa och hantera alla enheter som är eller har varit inloggade på ditt konto.",
  Description: "Beskrivning",
  Device: "Enhet",
  "Last seen": "Senast sedd",
  Actions: "Åtgärder",
  "No devices found. Devices will appear here after signing in.":
    "Inga enheter hittades. Enheter visas här efter inloggning.",
  "No devices match your filters.": "Inga enheter matchar dina filter.",
  "This device": "Denna enhet",
  Hide: "Dölj",
  Logout: "Logga ut",
  "Unnamed device": "Namnlös enhet",
  "Search devices…": "Sök enheter…",
  "All statuses": "Alla statusar",
  "Logout queued": "Utloggning köad",
  "Logged out": "Utloggad",
  "Show hidden": "Visa dolda",
  "Logout all": "Logga ut alla",
  "Hide Device": "Dölj enhet",
  "Logout From All Devices": "Logga ut från alla enheter",
  "Logout Device": "Logga ut enhet",
  "Logout all and delete data": "Logga ut alla och radera data",
  "Logout and delete device data": "Logga ut och radera enhetsdata",
  "Just now": "Just nu",
  "{{count}}h ago": "{{count}}t sedan",
  "{{count}}d ago": "{{count}}d sedan",
  "Not seen yet": "Inte sedd ännu",

  // Device detail
  "Reminder status": "Påminnelsestatus",
  "Not available": "Inte tillgänglig",
  "Reminders are not available on web":
    "Påminnelser är inte tillgängliga på webben",
  "Device permissions": "Enhetsbehörigheter",
  "Local notifications": "Lokala aviseringar",
  "Background execution": "Bakgrundskörning",
  "Notifications enabled (system)": "Aviseringar aktiverade (system)",
  "Exact alarms": "Exakta alarm",
  "Background restricted": "Bakgrund begränsad",
  "Background App Refresh": "Bakgrundsuppdatering av app",
  "Use the button below to enable push notifications on this device.":
    "Använd knappen nedan för att aktivera push-aviseringar på denna enhet.",
  Locations: "Platser",
  "Got it": "Uppfattat",
  Enabled: "Aktiverad",
  Disabled: "Inaktiverad",
  "Pending logout": "Väntar på utloggning",
  "Show deleted": "Visa raderade",

  // Device helpers — status config
  "Push, local notifications, and alarms are all enabled.":
    "Push, lokala aviseringar och alarm är alla aktiverade.",
  "Some permissions are missing. Reminders may not work reliably.":
    "Vissa behörigheter saknas. Påminnelser kanske inte fungerar tillförlitligt.",
  "Push notifications are disabled. Enable them in device settings.":
    "Push-aviseringar är inaktiverade. Aktivera dem i enhetsinställningar.",
  Limited: "Begränsad",
  Off: "Av",

  // ===========================================================================
  // SETTINGS — Email
  // ===========================================================================
  // "Email to To To-Do" translation is in the Subscription section below
  "How it works": "Hur det fungerar",
  "Send emails to a unique address to automatically create tasks in your inbox.":
    "Skicka e-post till en unik adress för att automatiskt skapa uppgifter i din inkorg.",
  "Enable email inbox": "Aktivera e-postinkorg",
  "Disable email inbox": "Inaktivera e-postinkorg",
  "Enabling…": "Aktiverar…",
  "Disabling…": "Inaktiverar…",
  "Your personal task email address": "Din personliga uppgifts-e-postadress",
  "Copy to clipboard": "Kopiera till urklipp",
  "Send yourself to-dos from a PC":
    "Skicka uppgifter till dig själv från en dator",
  "Forward emails from the Mail app": "Vidarebefordra e-post från e-postappen",
  "Share your address with a trusted colleague":
    "Dela din adress med en betrodd kollega",
  "Use automation services like IFTTT or Zapier":
    "Använd automatiseringstjänster som IFTTT eller Zapier",
  "Attachments are not supported. Maximum 2000 characters.":
    "Bilagor stöds inte. Maximalt 2000 tecken.",
  "Email-to-Task feature enabled successfully":
    "Funktionen E-post-till-uppgift har aktiverats",
  "Failed to enable Email-to-Task feature":
    "Det gick inte att aktivera funktionen E-post-till-uppgift",
  "Email-to-Task feature disabled":
    "Funktionen E-post-till-uppgift har inaktiverats",
  "Failed to disable Email-to-Task feature":
    "Det gick inte att inaktivera funktionen E-post-till-uppgift",
  "Task email address copied to clipboard":
    "Uppgiftsadressen har kopierats till urklipp",
  "Failed to copy email address": "Det gick inte att kopiera e-postadressen",

  // ===========================================================================
  // SETTINGS — Calendar
  // ===========================================================================
  "Calendar integration": "Kalenderintegration",
  "Add external calendars via iCal URL to see your events alongside your tasks.":
    "Lägg till externa kalendrar via iCal-URL för att se dina händelser bredvid dina uppgifter.",
  "No calendars added yet. Add a calendar to get started.":
    "Inga kalendrar tillagda ännu. Lägg till en kalender för att komma igång.",
  "Add calendar": "Lägg till kalender",
  "Invalid URL format": "Ogiltigt URL-format",
  "Could not fetch calendar. Please check the URL and try again.":
    "Kunde inte hämta kalendern. Kontrollera URL:en och försök igen.",
  "The URL does not appear to contain valid iCal data.":
    "URL:en verkar inte innehålla giltig iCal-data.",
  "Validating…": "Validerar…",
  "Name your calendar": "Namnge din kalender",
  "Paste calendar URL (supports webcal:// and https://)":
    "Klistra in kalender-URL (stöder webcal:// och https://)",
  "Are you sure you want to delete this calendar":
    "Är du säker på att du vill ta bort denna kalender",
  "{{name}} will be removed from your calendar list. This action cannot be undone.":
    "{{name}} kommer att tas bort från din kalenderlista. Denna åtgärd kan inte ångras.",
  "Show more ({{count}})": "Visa mer ({{count}})",
  "Add external calendars via iCal URL to see events alongside your tasks.":
    "Lägg till externa kalendrar via iCal-URL för att se händelser bredvid dina uppgifter.",
  "No calendars added yet. Add a calendar subscription to see events in your Today and Upcoming views.":
    "Inga kalendrar tillagda ännu. Lägg till en kalenderprenumeration för att se händelser i Idag och Kommande.",
  "Supports {{https}} and {{webcal}} URLs. Find your calendar's subscription URL in Google Calendar, Outlook, or Apple Calendar settings.":
    "Stöder {{https}}- och {{webcal}}-URL:er. Prenumerationsadressen hittar du i inställningarna för Google Kalender, Outlook eller Apple Kalender.",
  "Unnamed calendar": "Namnlös kalender",
  "No URL": "Ingen URL",
  "Calendar name (auto-detected if empty)":
    "Kalendernamn (hämtas automatiskt om tomt)",
  "Only https:// and webcal:// calendar links are supported.":
    "Endast kalenderlänkar som börjar med https:// eller webcal:// stöds.",
  "Validation failed": "Valideringen misslyckades",
  Color: "Färg",
  Refresh: "Uppdatera",
  "Updating…": "Uppdaterar…",
  "{{count}} events, {{recurring}} recurring":
    "{{count}} händelser, {{recurring}} återkommande",
  "updated {{time}}": "uppdaterad {{time}}",
  "Showing data from {{time}}.": "Visar data från {{time}}.",
  "{{count}} events could not be read and are not shown.":
    "{{count}} händelser kunde inte läsas och visas inte.",
  "{{count}} recurring events could not be read and are shown once.":
    "{{count}} återkommande händelser kunde inte läsas och visas bara en gång.",
  "Unrecognised time zone ({{zones}}): those events are shown in the calendar's or your own time zone.":
    "Okänd tidszon ({{zones}}): de händelserna visas i kalenderns eller din egen tidszon.",
  "Could not reach the calendar service. Check your connection.":
    "Kunde inte nå kalendertjänsten. Kontrollera din anslutning.",
  "The calendar link was refused. Use a public https:// or webcal:// link.":
    "Kalenderlänken nekades. Använd en publik https://- eller webcal://-länk.",
  "Sign in again to update your calendars.":
    "Logga in igen för att uppdatera dina kalendrar.",
  "The calendar is too large (over 5 MB).":
    "Kalendern är för stor (över 5 MB).",
  "Too many calendar updates right now. Try again in a minute.":
    "För många kalenderuppdateringar just nu. Försök igen om en minut.",
  "The calendar server returned an error.":
    "Kalenderservern svarade med ett fel.",
  "The calendar server took too long to answer.":
    "Kalenderservern tog för lång tid att svara.",
  "The link does not lead to an iCal calendar.":
    "Länken leder inte till en iCal-kalender.",
  "The calendar could not be read.": "Kalendern kunde inte läsas.",
  "None of the calendar's events could be read.":
    "Ingen av kalenderns händelser kunde läsas.",
  "Could not fetch the calendar ({{status}}).":
    "Kunde inte hämta kalendern ({{status}}).",
  "Calendar feed": "Kalenderflöde",
  "Subscribe to your tasks in external calendar apps like Google Calendar or Apple Calendar.":
    "Prenumerera på dina uppgifter i externa kalenderappar som Google Kalender eller Apple Kalender.",
  "Generate a private URL to subscribe to your tasks as a calendar feed.":
    "Skapa en privat URL för att prenumerera på dina uppgifter som ett kalenderflöde.",
  "Generate feed URL": "Skapa flödes-URL",
  "Copied!": "Kopierat!",
  "Add this URL as a calendar subscription. It updates automatically with your recurring tasks and due dates.":
    "Lägg till den här URL:en som kalenderprenumeration. Den uppdateras automatiskt med dina återkommande uppgifter och förfallodatum.",
  "Regenerate URL": "Skapa ny URL",

  // ===========================================================================
  // SETTINGS — Import & Export
  // ===========================================================================
  "Export data": "Exportera data",
  "Export settings": "Exportera inställningar",
  "Import from Things 3": "Importera från Things 3",
  "Download your entire database as a JSON file.":
    "Ladda ner hela din databas som en JSON-fil.",
  "Importing…": "Importerar…",
  "Drag & drop a JSON file here, or click to browse":
    "Dra och släpp en JSON-fil här, eller klicka för att bläddra",

  // ===========================================================================
  // SETTINGS — Help
  // ===========================================================================
  "Quick start": "Snabbstart",
  "Tutorial project": "Instruktionsprojekt",
  "Report a bug": "Rapportera en bugg",
  "Error logs": "Felloggar",
  Bug: "Bugg",
  "Feature request": "Funktionsönskemål",
  "Title (min 10 characters)": "Titel (minst 10 tecken)",
  "Description (min 50 characters)": "Beskrivning (minst 50 tecken)",
  "Submitting…": "Skickar…",
  "Submit report": "Skicka rapport",
  "Join our Discord community": "Gå med i vår Discord-gemenskap",
  Title: "Titel",
  Send: "Skicka",
  "The title must be at least 10 characters long":
    "Titeln måste vara minst 10 tecken lång",
  "The description must be at least 50 characters long":
    "Beskrivningen måste vara minst 50 tecken lång",
  "Please select a type": "Vänligen välj en typ",
  "Request a new feature": "Önska en ny funktion",
  "Error sending report": "Fel vid sändning av rapport",
  "Request sent": "Förfrågan skickad",
  "Get started in minutes with a step-by-step guide to help you set up your workspace and create your first tasks.":
    "Kom igång på några minuter med en steg-för-steg-guide som hjälper dig att ställa in din arbetsyta och skapa dina första uppgifter.",
  "Our support lives on Discord, where the team and community work together to answer questions, troubleshoot issues, and improve To To-Do. It's fast, personal, and built on real conversations—not tickets. Join us to connect, share ideas, and help build the ultimate productivity app.":
    "Vår support finns på Discord, där teamet och gemenskapen arbetar tillsammans för att besvara frågor, felsöka problem och förbättra To To-Do. Det är snabbt, personligt och byggt på verkliga konversationer. Gå med oss för att mötas, dela idéer och hjälpa till att bygga den ultimata produktivitetsappen.",

  // ===========================================================================
  // SETTINGS — About
  // ===========================================================================
  "To To-Do": "To To-Do",
  "Made by Zenta AB": "Gjord av Zenta AB",
  "Device information": "Enhetsinformation",
  "Get the app": "Hämta appen",
  API: "API",
  Legal: "Juridiskt",
  "Web App": "Webbapp",
  "App Store": "App Store",
  "Google Play": "Google Play",
  "Privacy Policy": "Integritetspolicy",
  "Terms of Use": "Användarvillkor",

  // ===========================================================================
  // SETTINGS — Statuses
  // ===========================================================================
  "Task statuses": "Uppgiftsstatusar",
  "Add status": "Lägg till status",

  // ===========================================================================
  // SETTINGS — Developer
  // ===========================================================================
  "Factory reset": "Fabriksåterställning",
  "Debug log": "Felsökningslogg",
  "Database browser": "Databasbläddrare",
  "This will delete ALL local data. Are you sure?":
    "Detta kommer att radera ALL lokal data. Är du säker?",
  "Reset with test data": "Återställ med testdata",
  "Clear log": "Rensa logg",
  "Filter logs…": "Filtrera loggar…",

  // ==========================================================================
  // SETTINGS — API access
  // ==========================================================================
  "API access": "API-åtkomst",
  "Create API keys for external automations and integrations. Keys are shown once, can be revoked at any time, and should never be shared publicly.":
    "Skapa API-nycklar för externa automationer och integrationer. Nycklar visas bara en gång, kan återkallas när som helst och ska aldrig delas offentligt.",
  "Create key": "Skapa nyckel",
  "No API keys yet. Create one to connect To To-Do with external tools.":
    "Du har inga API-nycklar ännu. Skapa en för att koppla To To-Do till externa verktyg.",
  Created: "Skapad",
  Expires: "Upphör",
  "Last used": "Senast använd",
  "Never used": "Aldrig använd",
  Revoked: "Återkallad",
  Expired: "Utgången",
  Revoke: "Återkalla",
  "Create API key": "Skapa API-nyckel",
  "Use a descriptive name so you can identify where the key is used later.":
    "Använd ett tydligt namn så att du senare kan se var nyckeln används.",
  Name: "Namn",
  "Access level": "Åtkomstnivå",
  Expiration: "Utgångstid",
  "Read only": "Endast läsning",
  "Read & write": "Läs och skriv",
  "Full access": "Full åtkomst",
  "Can read tasks, projects, reminders, and files.":
    "Kan läsa uppgifter, projekt, påminnelser och filer.",
  "Can read and modify tasks, projects, reminders, and files.":
    "Kan läsa och ändra uppgifter, projekt, påminnelser och filer.",
  "Includes write access and webhook management.":
    "Inkluderar skrivåtkomst och hantering av webhooks.",
  "30 days": "30 dagar",
  "90 days": "90 dagar",
  "1 year": "1 år",
  Never: "Aldrig",
  "Name is required": "Namn krävs",
  "Failed to load API keys": "Det gick inte att läsa in API-nycklar",
  "Failed to create API key": "Det gick inte att skapa API-nyckeln",
  "Failed to revoke API key": "Det gick inte att återkalla API-nyckeln",
  "Failed to rename API key": "Det gick inte att byta namn på API-nyckeln",
  "Failed to rotate API key": "Det gick inte att rotera API-nyckeln",
  'Revoke API key "{{name}}"? Existing integrations using it will stop working immediately.':
    'Återkalla API-nyckeln "{{name}}"? Befintliga integrationer som använder den slutar fungera direkt.',
  'Rotate API key "{{name}}"? The old key will be immediately revoked and a new one created.':
    'Rotera API-nyckeln "{{name}}"? Den gamla nyckeln återkallas direkt och en ny skapas.',
  "API key revoked": "API-nyckeln återkallades",
  "API key renamed": "API-nyckeln bytte namn",
  "Failed to copy API key": "Det gick inte att kopiera API-nyckeln",
  "Save your API key": "Spara din API-nyckel",
  "This is the only time the full key will be shown. Copy it now and store it securely.":
    "Det här är enda gången hela nyckeln visas. Kopiera den nu och spara den säkert.",
  "If you lose this key, you must revoke it and create a new one.":
    "Om du tappar bort nyckeln måste du återkalla den och skapa en ny.",
  "Copy key": "Kopiera nyckel",
  "Lovable dashboard": "Lovable-dashboard",
  "Creating…": "Skapar…",
  Rename: "Byt namn",
  Rotate: "Rotera",
  Requests: "Anrop",
  "Failed to load API key usage": "Det gick inte att läsa in användningsstatistik för API-nyckeln",
  "Rename API key": "Byt namn på API-nyckel",
  "Give this key a descriptive name so you can identify it later.":
    "Ge nyckeln ett beskrivande namn så att du kan identifiera den senare.",

  // ===========================================================================
  // SETTINGS — Footer / misc
  // ===========================================================================
  "Signing in…": "Loggar in…",
  "Loading...": "Laddar...",
  "Loading…": "Laddar…",
  Loading: "Laddar",

  // ===========================================================================
  // SUBSCRIPTION PLANS — subscriptionPlans.ts, plan comparison
  // ===========================================================================
  "Number of tasks": "Antal uppgifter",
  "Data backup": "Data backup",
  Synchronization: "Synkronisering",
  Collaboration: "Samarbete",
  "Calendar integrations": "Kalenderintegrationer",
  "Email to To To-Do": "E-post till To To-Do",
  Images: "Bilder",
  "Sharable templates": "Delade mallar",
  "AI requests": "AI-förfrågningar",
  Unlimited: "Obegränsad",
  "100 / month": "100 / månad",
  "1000 / month": "1000 / månad",
  "billed monthly": "faktureras månadsvis",
  "billed annually": "faktureras årligen",
  "billed every 2 years": "faktureras varannan år",
  "per month": "per månad",

  // ===========================================================================
  // AUTH — SignIn, GenericInteraction, MessageAlert, LogoutConfirmation
  // ===========================================================================
  "Sign in": "Logga in",
  "Check your email": "Kolla din e-post",
  "Verify code": "Verifiera kod",
  Continue: "Fortsätt",
  "Enter the code we sent to your email":
    "Ange koden vi skickade till din e-post",
  "We'll send you a login code": "Vi skickar dig en inloggningskod",
  "Enter your email address": "Ange din e-postadress",
  "Enter code": "Ange kod",
  "Sending…": "Skickar…",
  "Verifying…": "Verifierar…",
  "Or sign in with": "Eller logga in med",
  "OTP login": "OTP-inloggning",
  "Code from email": "Kod från e-post",
  Resend: "Skicka igen",
  "INVALID OTP": "OGILTIG OTP",
  "The code you entered is incorrect or has expired. Please try again or request a new one.":
    "Koden du angav är felaktig eller har gått ut. Försök igen eller begär en ny.",
  "This e-mail address is invalid.": "Den här e-postadressen är ogiltig.",
  "There was a problem logging in, please contact support if the problem persists.":
    "Det uppstod ett problem vid inloggning, kontakta supporten om problemet kvarstår.",
  "Logging out…": "Loggar ut…",
  "Are you sure you want to log out?": "Är du säker på att du vill logga ut?",
  "Your data is safe and will be here when you log back in.":
    "Din data är trygg och kommer att finnas här när du loggar in igen.",
  OK: "OK",
  "Sign in with email": "Logga in med e-post",
  or: "eller",
  "Sign up is done automatically on sign in.":
    "Ett konto skapas automatiskt när du loggar in.",
  "By signing up you agree to our": "Genom att registrera dig godkänner du våra",
  "Terms of Service": "användarvillkor",
  "Paste code from email": "Klistra in kod från e-post",
  "Invalid email code": "Ogiltig e-postkod",
  "Action required": "Åtgärd krävs",
  "Your workspace has reached the maximum number of users for your current plan.":
    "Din arbetsyta har nått det maximala antalet användare för din nuvarande plan.",
  "You have {{count}} unsynced changes that will be lost if you sign out.":
    "Du har {{count}} osynkade ändringar som kommer att gå förlorade om du loggar ut.",
  "You have unsynced changes that will be lost if you sign out.":
    "Du har osynkade ändringar som kommer att gå förlorade om du loggar ut.",

  // ===========================================================================
  // SidebarLicense — subscription warnings
  // ===========================================================================
  "Your trial expires in {{days}} days. Upgrade to keep syncing.":
    "Din provperiod går ut om {{days}} dagar. Uppgradera för att fortsätta synkronisera.",
  "Your trial ends tomorrow. Upgrade now to keep syncing.":
    "Din provperiod slutar imorgon. Uppgradera nu för att fortsätta synkronisera.",
  "Trial expired. Upgrade to sync and back up.":
    "Provperioden har gått ut. Uppgradera för att synkronisera och säkerhetskopiera.",
  "License expired. Renew to sync and back up.":
    "Licensen har gått ut. Förnya för att synkronisera och säkerhetskopiera.",
  Offline: "Offline",
  "Stay in sync": "Fortsätt synkronisera",

  // ===========================================================================
  // EDITOR
  // ===========================================================================
  "Write something…": "Skriv något…",
  "Write, type '/' for commands…": "Skriv, tryck '/' för kommandon…",
  "Enter a quote": "Skriv ett citat",
  "Project notes…": "Projektanteckningar…",
  "List notes…": "Listanteckningar…",
  Saved: "Sparad",
  Disconnected: "Frånkopplad",

  // ===========================================================================
  // TIPTAP UI — AI menu, slash commands, formatting
  // ===========================================================================
  "Fix spelling & grammar": "Fixa stavning & grammatik",
  "Extend text": "Förläng text",
  "Reduce text": "Förkorta text",
  "Simplify text": "Förenkla text",
  Emojify: "Emojifiera",
  "Complete sentence": "Slutför mening",
  Summarize: "Sammanfatta",
  "Adjust tone": "Ändra ton",
  Translate: "Översätt",
  Improve: "Förbättra",
  "Ask AI": "Fråga AI",
  "Make longer": "Gör längre",
  "Make shorter": "Gör kortare",
  "Simplify language": "Förenkla språk",
  "Improve writing": "Förbättra skrivande",
  "Continue writing": "Fortsätt skriva",
  "Add a summary": "Lägg till sammanfattning",
  Languages: "Språk",
  Edit: "Redigera",
  "Tell AI what else needs to be changed...":
    "Berätta för AI vad mer som behöver ändras...",
  Tone: "Ton",
  Stop: "Stoppa",
  "Turn into": "Omvandla till",

  // AI tone labels
  Academic: "Akademisk",
  Business: "Affärsmässig",
  Casual: "Avslappnad",
  Childfriendly: "Barnvänlig",
  Conversational: "Samtalsmässig",
  Emotional: "Emotionell",
  Informative: "Informativ",
  Inspirational: "Inspirerande",
  Memeify: "Memeify",
  Narrative: "Berättande",
  Objective: "Objektiv",
  Persuasive: "Övertygande",
  Poetic: "Poetisk",
  Humorous: "Humoristisk",
  Professional: "Professionell",
  Confident: "Självsäker",
  Direct: "Direkt",
  Empathetic: "Empatisk",
  Formal: "Formell",
  Friendly: "Vänlig",

  // Slash command items
  "Continue Writing": "Fortsätt skriva",
  "Continue writing from the current position":
    "Fortsätt skriva från nuvarande position",
  "Ask AI to generate content": "Be AI generera innehåll",
  Text: "Text",
  "Regular text paragraph": "Vanligt textstycke",
  "Heading 1": "Rubrik 1",
  "Heading 2": "Rubrik 2",
  "Heading 3": "Rubrik 3",
  "High priority section title": "Högprioriterad avsnittsrubrik",
  "Medium priority section title": "Medium-prioriterad avsnittsrubrik",
  "Low priority section title": "Lågprioriterad avsnittsrubrik",
  "Bullet List": "Punktlista",
  "Unordered list of items": "Oordnad lista med objekt",
  "Numbered List": "Numrerad lista",
  "Ordered list of items": "Numrerad lista med objekt",
  "To-do list": "Att göra-lista",
  "Task list with checkboxes": "Uppgiftslista med kryssrutor",
  Blockquote: "Blockcitat",
  "Element for quoting": "Element för citat",
  "Code Block": "Kodblock",
  "Code block with syntax highlighting": "Kodblock med syntaxmarkering",
  Mention: "Omnämning",
  "Mention a user or task": "Omnämn en användare eller uppgift",
  Emoji: "Emoji",
  "Insert an emoji": "Infoga en emoji",
  Table: "Tabell",
  "Insert a table": "Infoga en tabell",
  Separator: "Avskiljare",
  "Insert a horizontal divider": "Infoga en horisontell avdelare",
  "Table of contents": "Innehållsförteckning",
  "Auto-generated outline": "Automatiskt genererad disposition",
  Image: "Bild",
  "Upload an image": "Ladda upp en bild",
  AI: "AI",
  Style: "Stil",
  Insert: "Infoga",
  Upload: "Ladda upp",
  "Filter...": "Filtrera...",

  // Link popover
  Link: "Länk",
  "Paste a link...": "Klistra in en länk...",
  "Remove link": "Ta bort länk",

  // Undo / Redo
  Redo: "Gör om",

  // Other tiptap-ui
  "Add mention": "Lägg till omnämning",
  "Add image": "Lägg till bild",
  "Add emoji": "Lägg till emoji",
  "Add a emoji reaction...": "Lägg till en emoji-reaktion...",
  "Remove highlight": "Ta bort markering",
  "Text Highlighter": "Textmarkerare",
  "Link Editor": "Länkredigerare",

  // ===========================================================================
  // APP COMPONENTS — DatabaseProvider, errors
  // ===========================================================================
  "Database Error": "Databasfel",
  "Try again": "Försök igen",
  "Setup Error": "Installationsfel",
  "Collaboration:": "Samarbete:",

  // ===========================================================================
  // PLACEHOLDER — dev page
  // ===========================================================================
  "Coming soon": "Kommer snart",
  "Are you sure you want to delete ALL your data? This cannot be undone.":
    "Är du säker på att du vill radera ALL din data? Detta kan inte ångras.",
  "Factory reset complete. Reload to re-sync from cloud.":
    "Fabriksåterställning klar. Ladda om för att synka från molnet.",
  "Factory reset failed — check console.":
    "Fabriksåterställning misslyckades — se konsolen.",

  // ===========================================================================
  // COMMON / SHARED
  // ===========================================================================
  Yes: "Ja",
  No: "Nej",
  Back: "Tillbaka",
  Next: "Nästa",
  Previous: "Föregående",
  Create: "Skapa",
  Update: "Uppdatera",
  Remove: "Ta bort",
  Clear: "Rensa",
  Reset: "Återställ",
  Retry: "Försök igen",
  Apply: "Tillämpa",
  Discard: "Kasta",
  Select: "Välj",
  Selected: "Vald",
  "Select All": "Markera alla",
  "Deselect All": "Avmarkera alla",
  "{{count}} Selected": "{{count}} markerade",
  None: "Ingen",
  All: "Alla",
  More: "Mer",
  Less: "Mindre",
  Other: "Annat",
  Default: "Standard",
  Custom: "Anpassad",
  Details: "Detaljer",
  Info: "Info",
  Warning: "Varning",
  Error: "Fel",
  Success: "Lyckades",
  Tags: "Taggar",
  Notes: "Anteckningar",
  Share: "Dela",
  "Copy Link": "Kopiera länk",
  "Link copied": "Länk kopierad",
  "Copied to clipboard": "Kopierat till urklipp",
  "No logged in user": "Ingen inloggad användare",

  // --- Stale task detection ---
  "Task no longer exists": "Uppgiften finns inte längre",
  "Task was deleted": "Uppgiften raderades",
  "Task was completed": "Uppgiften slutfördes",
  "Task was canceled": "Uppgiften avbröts",
  "Task moved out of this view": "Uppgiften har flyttats från den här vyn",

  // --- Error Boundary ---
  "Oops, something went wrong": "Hoppsan, något gick fel",
  "If none of the below works, please restart the app and try again or contact":
    "Om inget nedan fungerar, starta om appen och försök igen eller kontakta",
  Reload: "Ladda om",
  "Go to start": "Gå till start",
  "Error details": "Feldetaljer",
  Copied: "Kopierat",
  Copy: "Kopiera",

  // --- 404 Not Found ---
  "Page not found": "Sidan hittades inte",
  "The page you're looking for doesn't exist or has been moved.":
    "Sidan du letar efter finns inte eller har flyttats.",
  "Go back": "Gå tillbaka",
  "Go to Today": "Gå till Idag",

  // --- Offline Indicator ---
  "You're offline — changes will sync when you reconnect":
    "Du är offline — ändringar synkas när du ansluter igen",
  "Back online": "Online igen",

  // --- Logout ---
  "Signs you out while keeping your data safe on this device. You can log in again with the same account.":
    "Loggar ut dig men behåller dina data på den här enheten. Du kan logga in igen med samma konto.",
  "Your data will be preserved on this device. You can log in again with the same account.":
    "Dina data bevaras på den här enheten. Du kan logga in igen med samma konto.",
  "Signing out…": "Loggar ut…",
  "Unsynced changes": "Osynkade ändringar",
  "Some changes haven't been synced to the cloud yet. If you sign out now, these changes may be lost.":
    "Vissa ändringar har inte synkats till molnet ännu. Om du loggar ut nu kan dessa ändringar gå förlorade.",
  "You are offline. Changes made since your last sync cannot be saved to the cloud. If you sign out now, these changes may be lost.":
    "Du är offline. Ändringar gjorda sedan din senaste synk kan inte sparas till molnet. Om du loggar ut nu kan dessa ändringar gå förlorade.",
  "Keep my data": "Behåll mina data",
  "Sign out anyway": "Logga ut ändå",
  "Deleting local data…": "Tar bort lokal data…",
  "Error during logout. Reloading…": "Fel vid utloggning. Laddar om…",

  // --- Onboarding ---
  "Welcome to a better life!": "Välkommen till ett bättre liv!",
  "We've created a quick tutorial to help you get started. You can always recreate it from Settings.":
    "Vi har skapat en snabb guide för att hjälpa dig komma igång. Du kan alltid återskapa den från Inställningar.",
  "Get started": "Kom igång",
  "Get to know To To-Do": "Lär känna To To-Do",
  "Learn the basics": "Lär dig grunderna",
  "Click this to-do to see the details":
    "Klicka på denna uppgift för att se detaljerna",
  "Create a new to-do by pressing the + button":
    "Skapa en ny uppgift genom att trycka på +-knappen",
  "Add this to-do to your Today list":
    "Lägg till denna uppgift i din Idag-lista",
  "Plan this to-do for later using the calendar":
    "Planera denna uppgift till senare med kalendern",
  "Create a new heading to organize your tasks":
    "Skapa en ny rubrik för att organisera dina uppgifter",
  "Create a list or project from the sidebar":
    "Skapa en lista eller ett projekt från sidopanelen",
  "Boost your productivity": "Öka din produktivitet",
  "Tag your to-dos for easy filtering":
    "Tagga dina uppgifter för enkel filtrering",
  "Go step by step with checklists": "Gå steg för steg med checklistor",
  "Convert a to-do into a project": "Konvertera en uppgift till ett projekt",
  "Before you go…": "Innan du går…",
  "Get To To-Do for other devices": "Hämta To To-Do för andra enheter",
  "Any questions? Contact support@totodo.app":
    "Har du frågor? Kontakta support@totodo.app",

  // Tutorial task doc content
  "Great job! You just opened your first to-do. This is where you can add notes, checklists, tags, and more. Try checking off this task when you're done!":
    "Bra jobbat! Du har precis öppnat din första uppgift. Här kan du lägga till anteckningar, checklistor, taggar och mer. Prova att bocka av denna uppgift när du är klar!",
  "Tap the + button at the bottom of the screen to create a new to-do. You can also use the keyboard shortcut Ctrl+N (or Cmd+N on Mac).":
    "Tryck på +-knappen längst ned på skärmen för att skapa en ny uppgift. Du kan också använda kortkommandot Ctrl+N (eller Cmd+N på Mac).",
  "Tap the star icon to add this to-do to your Today list. Tasks in Today appear in your daily view so you always know what to focus on.":
    "Tryck på stjärnikonen för att lägga till denna uppgift i din Idag-lista. Uppgifter i Idag visas i din dagliga vy så att du alltid vet vad du ska fokusera på.",
  "Tap the calendar icon to schedule this to-do for a specific date. Scheduled tasks move to the Upcoming view and appear in Today when the day arrives.":
    "Tryck på kalenderikonen för att schemalägga denna uppgift till ett specifikt datum. Schemalagda uppgifter flyttas till Kommande-vyn och visas i Idag när dagen kommer.",
  "Headings help you group related tasks within a project. Use them to create sections like \"Research\", \"Design\", or \"Follow up\".":
    "Rubriker hjälper dig att gruppera relaterade uppgifter inom ett projekt. Använd dem för att skapa avsnitt som \"Research\", \"Design\" eller \"Uppföljning\".",
  "Projects help you organize larger efforts with multiple steps. Tap the + button in the sidebar to create a new project or list.":
    "Projekt hjälper dig att organisera större arbeten med flera steg. Tryck på +-knappen i sidopanelen för att skapa ett nytt projekt eller en lista.",
  "Tags let you categorize tasks across different projects. Add a tag by using the tag button in the task details. Filter by tag from the sidebar.":
    "Taggar låter dig kategorisera uppgifter över olika projekt. Lägg till en tagg med taggknappen i uppgiftsdetaljerna. Filtrera efter tagg från sidopanelen.",
  "Break down complex tasks into smaller steps using checklists. Open a to-do and tap the checklist button to add step-by-step items.":
    "Bryt ner komplexa uppgifter i mindre steg med checklistor. Öppna en uppgift och tryck på checklisteknappen för att lägga till steg-för-steg-punkter.",
  'When a to-do grows too complex for a single task, convert it into a project. Open the task menu and select "Convert to Project" to get started.':
    "När en uppgift blir för komplex för en enskild uppgift, konvertera den till ett projekt. Öppna uppgiftsmenyn och välj \"Konvertera till projekt\" för att komma igång.",
  "To To-Do syncs across all your devices. Download it on iOS and Android, or use the web app. Your data stays in sync automatically.":
    "To To-Do synkar mellan alla dina enheter. Ladda ner den på iOS och Android, eller använd webbappen. Dina data synkar automatiskt.",
  "We're here to help! Send us an email at support@totodo.app and we'll get back to you as soon as possible.":
    "Vi finns här för att hjälpa! Skicka ett mejl till support@totodo.app så återkommer vi så snart som möjligt.",

  // Month names
  January: "Januari",
  February: "Februari",
  March: "Mars",
  April: "April",
  May: "Maj",
  June: "Juni",
  July: "Juli",
  August: "Augusti",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "December",

  // Language names (for settings)
  English: "Engelska",
  Swedish: "Svenska",
  German: "Tyska",
  French: "Franska",
  Spanish: "Spanska",
  Portuguese: "Portugisiska",
  Italian: "Italienska",
  Dutch: "Holländska",
  Norwegian: "Norska",
  Danish: "Danska",
  Finnish: "Finska",
  Polish: "Polska",
  Romanian: "Rumänska",
  Russian: "Ryska",
  Ukrainian: "Ukrainska",
  Turkish: "Turkiska",
  Korean: "Koreanska",
  Chinese: "Kinesiska",
  Hindi: "Hindi",
  Arabic: "Arabiska",
  Vietnamese: "Vietnamesiska",
  Indonesian: "Indonesiska",
  Tagalog: "Tagalog",
  Bosnian: "Bosniska",
  Japanese: "Japanska",

  // --- Guest link sharing ---
  "Guest link": "Gästlänk",
  "Create guest link": "Skapa gästlänk",
  "Revoke guest link": "Ta bort gästlänk",
  "Anyone with this link can view this To To-Do.":
    "Alla med den här länken kan visa denna To To-Do.",
  "Create a guest link to let anyone view this To To-Do without an account.":
    "Skapa en gästlänk så att vem som helst kan visa denna To To-Do utan konto.",
  "Copy link": "Kopiera länk",
  "This share link is no longer valid":
    "Den här delningslänken är inte längre giltig",
  "The link may have expired or been revoked by the owner.":
    "Länken kan ha gått ut eller tagits bort av ägaren.",
  "Something went wrong": "Något gick fel",
  "Could not load the shared content. Please try again later.":
    "Kunde inte ladda det delade innehållet. Försök igen senare.",
  "Go to ToToDo": "Gå till ToToDo",
  "Shared project": "Delat projekt",
  "Shared list": "Delad lista",
  "{{count}} task": "{{count}} uppgift",
  "{{count}} task_plural": "{{count}} uppgifter",
  "No tasks yet": "Inga uppgifter ännu",
  "Want your own task lists?": "Vill du ha egna att-göra-listor?",
  "Try ToToDo for free": "Prova ToToDo gratis",
  "Shared via": "Delad via",

  // ===========================================================================
  // AI CHAT — History, groups, search
  // ===========================================================================
  "No conversations yet": "Inga konversationer ännu",
  "Search conversations...": "Sök konversationer...",
  'No conversations matching "{{query}}"':
    'Inga konversationer matchar "{{query}}"',
  Pinned: "Fästa",
  "This week": "Denna vecka",
  "Last week": "Förra veckan",
  "This month": "Denna månad",
  Older: "Äldre",
  Pin: "Fäst",
  Unpin: "Lossa",

  // ===========================================================================
  // OAUTH — consent page for MCP apps + Settings → API → Connected apps
  // ===========================================================================
  "Allow {{name}} to use your To To-Do?": "Vill du låta {{name}} använda din To To-Do?",
  "Signed in as {{email}}": "Inloggad som {{email}}",
  "Published by": "Publicerad av",
  "Unverified app: this app chose its own name, and we have not checked it.":
    "Overifierad app: appen valde sitt namn själv och vi har inte kontrollerat det.",
  "After you approve, you will be sent to": "När du godkänner skickas du till",
  "This sends access to an app on your own computer. Continue only if you just started signing in from it.":
    "Detta skickar åtkomst till en app på din egen dator. Fortsätt bara om du nyss började logga in från den.",
  "This gives it access to": "Detta ger den åtkomst till",
  "With these choices the app would get no access.": "Med dina val får appen ingen åtkomst.",
  "Asked for but not included": "Efterfrågat men inte med",
  "changes to your data": "ändringar av dina data",
  "To-dos": "Uppgifter",
  "Projects and lists": "Projekt och listor",
  Areas: "Områden",
  Reminders: "Påminnelser",
  "AI memory": "AI-minne",
  "read only": "endast läsa",
  "How much do you allow?": "Hur mycket tillåter du?",
  Read: "Läsa",
  "The app can look at your data but cannot change it.":
    "Appen kan titta på dina data men inte ändra dem.",
  "Read and change": "Läsa och ändra",
  "The app can also create, edit, complete and delete.":
    "Appen kan också skapa, redigera, slutföra och ta bort.",
  "Include AI memory": "Inkludera AI-minne",
  "What your AI assistant has learned about you. Off unless you turn it on.":
    "Det din AI-assistent har lärt sig om dig. Av om du inte slår på det.",
  Deny: "Neka",
  Approve: "Godkänn",
  "You can disconnect apps at any time in Settings, under API.":
    "Du kan koppla från appar när som helst i Inställningar, under API.",
  "Sending you back to the app…": "Skickar tillbaka dig till appen…",
  "This request has expired": "Begäran har gått ut",
  "This sign-in request has expired or was already used. Go back to the app and connect again.":
    "Inloggningsbegäran har gått ut eller har redan använts. Gå tillbaka till appen och anslut igen.",
  "We could not complete this request. Go back to the app and try again.":
    "Vi kunde inte slutföra begäran. Gå tillbaka till appen och försök igen.",
  "Something went wrong. Please try again.": "Något gick fel. Försök igen.",
  "Login failed": "Inloggningen misslyckades",
  "Login with {{provider}} failed": "Inloggningen med {{provider}} misslyckades",
  "We were unable to retrieve your information from your {{provider}} account. Please try again or contact support if the issue persists.":
    "Vi kunde inte hämta dina uppgifter från ditt {{provider}}-konto. Försök igen, eller kontakta supporten om det fortsätter.",
  "Signing in with {{provider}} was cancelled or not allowed. Try again, or sign in with an email code instead.":
    "Inloggningen med {{provider}} avbröts eller tilläts inte. Försök igen, eller logga in med en kod via e-post i stället.",
  "Close this window and try again in the app.": "Stäng det här fönstret och försök igen i appen.",
  "no answer": "inget svar",
  "Open To To-Do": "Öppna To To-Do",
  "Connected apps": "Anslutna appar",
  "Apps you allowed to use your To To-Do through the MCP connection, such as Claude. Disconnect an app to cut its access at once.":
    "Appar som du har tillåtit använda din To To-Do via MCP-anslutningen, till exempel Claude. Koppla från en app för att stänga av dess åtkomst direkt.",
  "No connected apps yet.": "Inga anslutna appar ännu.",
  Connected: "Ansluten",
  Disconnect: "Koppla från",
  'Disconnect "{{name}}"? It will lose access to your To To-Do immediately.':
    'Koppla från "{{name}}"? Appen förlorar åtkomsten till din To To-Do direkt.',
  "App disconnected": "Appen kopplades från",
  "Failed to load connected apps": "Det gick inte att läsa in anslutna appar",
  "Failed to disconnect app": "Det gick inte att koppla från appen",
  "Connected apps could not be loaded.": "Anslutna appar kunde inte läsas in.",
  "That does not mean nothing is connected. Try again in a moment.":
    "Det betyder inte att inget är anslutet. Försök igen om en stund.",
  "Error {{status}}": "Fel {{status}}",
  "The server could not be reached.": "Servern kunde inte nås.",
  Reference: "Referens",
  "Some older connections may be missing from this list right now.":
    "Äldre anslutningar kan saknas i listan just nu.",

  // ===========================================================================
  // AI QUOTA — messages used / limit, no-AI plan, refusals
  // ===========================================================================
  "No AI": "Ingen AI",
  "At most {{count}} files per message.": "Högst {{count}} filer per meddelande.",
  "Files can be at most 8 MB in all per message: {{names}}":
    "Filerna får vara högst 8 MB sammanlagt per meddelande: {{names}}",
  "AI is not included in your plan. Upgrade to Standard or Premium to use it.":
    "AI ingår inte i din plan. Uppgradera till Standard eller Premium för att använda den.",
  "AI messages used this month: {{used}} of {{limit}}. Resets {{date}}.":
    "AI-meddelanden den här månaden: {{used}} av {{limit}}. Återställs {{date}}.",
  "Upgrade to Premium for more.": "Uppgradera till Premium för fler.",
  "You have reached this month's AI limit. It resets {{date}}.":
    "Du har nått månadens AI-gräns. Den återställs {{date}}.",
  "next month": "nästa månad",
  "That took too many steps for one message. Try a smaller request.":
    "Det krävde för många steg för ett meddelande. Försök med en mindre begäran.",
  "AI is temporarily unavailable. Try again in a moment.":
    "AI är tillfälligt otillgänglig. Försök igen om en stund.",

  // Paste (menus and Cmd+V)
  Paste: "Klistra in",
  "Task created: {{title}}": "Uppgift skapad: {{title}}",
  "Task created": "Uppgift skapad",
  "{{count}} tasks created": "{{count}} uppgifter skapade",
  "Failed to paste tasks": "Det gick inte att klistra in uppgifterna",
  "Nothing to paste": "Inget att klistra in",

  // Undo toast descriptions (the operations' English literals are the keys)
  "Completed task": "Uppgiften klarmarkerad",
  "Uncompleted task": "Uppgiften återöppnad",
  "Canceled task": "Uppgiften avbruten",
  "Duplicated task": "Uppgiften duplicerad",
  "Deleted task": "Uppgiften borttagen",
  "Restored from trash": "Återställd från papperskorgen",
  "Moved task": "Uppgiften flyttad",
  "Cleared schedule": "Planeringen borttagen",
  "Scheduled task": "Uppgiften planerad",
  "Activated project": "Projektet aktiverat",
  "Completed project": "Projektet klarmarkerat",
  "Completed collection": "Samlingen klarmarkerad",
  "Canceled project": "Projektet avbrutet",
  "Canceled collection": "Samlingen avbruten",
  "Reopened project": "Projektet återöppnat",
  "Reopened collection": "Samlingen återöppnad",
  "Reopened {{n}} to-dos": "{{n}} uppgifter återöppnade",
  "Completed {{n}} tasks": "{{n}} uppgifter klarmarkerade",
  "Deleted {{n}} tasks": "{{n}} uppgifter borttagna",
  "Uncompleted {{n}} tasks": "{{n}} uppgifter återöppnade",
  "Scheduled {{n}} tasks": "{{n}} uppgifter planerade",
  "Canceled {{n}} tasks": "{{n}} uppgifter avbrutna",
  "Restored {{n}} tasks": "{{n}} uppgifter återställda",
  "Moved {{n}} tasks": "{{n}} uppgifter flyttade",
  "Set deadline on {{n}} tasks": "Deadline satt på {{n}} uppgifter",
  "Cleared deadline on {{n}} tasks": "Deadline borttagen från {{n}} uppgifter",
  "Plan: {{name}}": "Plan: {{name}}",
  "Moved {{n}} tasks to trash": "{{n}} uppgifter flyttade till papperskorgen",
  "Create task: {{name}}": "Skapa uppgift: {{name}}",
}
